import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import {
  search,
  loadData,
  updateData,
  deselectAllFilteredRows,
  deselectRow,
  selectAllFilteredRows,
  selectRow,
  selectRowsRange,
} from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import { kaPropsUtils } from "ka-table/utils";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import invoiceService from "../services/invoice-service";
import moment from "moment";
import { useForm } from "react-hook-form";

const tablePropsInit = {
  columns: [
    { key: "selection-cell" },
    { key: "payor", title: "Payor" },
    { key: "group", title: "Facility ID" },
    { key: "year", title: "Year" },
    { key: "month", title: "Month" },
    { key: "is_ready", title: "Is Published" },
    { key: "file_path", title: "Download" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },

  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const InvoiceList = ({ history, totalMonths, parentsList, totalYears }) => {
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState("hidden");
  const { register, getValues, setValue } = useForm({});
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [disablePublish, setDisablePublish] = useState(false);
  const [rows, setRows] = useState([]);
  const dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  const deleteInvoice = async (drgId) => {
    if (window.confirm("Are you sure to delete Invoice ?")) {
      setLoading(true);
      try {
        await invoiceService.deleteInv(drgId);
        const { hide } = cogoToast.success("Invoice deleted Successfully", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });  
        getInvoiceList();      
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while deleting Invoice. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
      setLoading(false);
    }
  };
  async function getInvoiceList(actnType) {
    let massinvoice_month = getValues("invoice_list_month");
    let massinvoice_year = getValues("invoice_list_year");
    let parentSelected = getValues("invoiceListParent");
    try {
      setLoading(true);
      setDisablePublish(false);
      let params = {
        year: massinvoice_year,
        month: massinvoice_month,
        parent: parentSelected,
      };
      let resp = await invoiceService.getInvoices(params);
      if (resp.length > 0) {
        setShowList("show");
        dispatch1(updateData(resp));
        setRows(resp)
      } else {
        setShowList("hidden");
        setRows([])
        dispatch1(updateData([]));
        const { hide } = cogoToast.error("No Records Found!", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error("Error while getting invoice list", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      setLoading(false);
    }
  }
  async function publishInvoice() {
    const selectedData = kaPropsUtils.getSelectedData(tableProps);
    if (selectedData.length > 0) {
      setDisablePublish(true);
      setTimeout(() => setDisablePublish(false),30000);
      let idsList = selectedData.map((x) => x.id);
      try {
        let resp = await invoiceService.publishList(idsList);
        if (resp) {
          const { hide } = cogoToast.success("Invoice published succesfully!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          setShowList("hidden");
          setValue("invoice_list_month", 0);
        } else {
          const { hide } = cogoToast.error(
            "Error while publishing invoice. Please contact administrator.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while publishing invoice. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      const { hide } = cogoToast.error(
        "Please select atleast one record to publish",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  const downloadReport = async (id) => {
    try {
      setLoading(true);
      let pdfData = await invoiceService.reportDownload(id);
      const linkSource = `data:application/pdf;base64,${pdfData}`;
      const downloadLink = document.createElement("a");
      const fileName = "invoice.pdf";  
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
    
  };

  const disableXMLDownload = (id,  value) =>{
    const rowIndex = rows.findIndex((row) => row.id === id);
    if(rowIndex !== -1) {
      rows[rowIndex].disableXMLDownload = value;
      setRows(rows)
      dispatch1(updateData(rows));
    }
  }
  const disablePdfDownload = (id,  value) =>{
    const rowIndex = rows.findIndex((row) => row.id === id);
    if(rowIndex !== -1) {
      rows[rowIndex].disablePdfDownload = value;
      setRows(rows)
      dispatch1(updateData(rows));
    }
  }
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        <a
          href={rowData.file_path}
          download="Invoice.xlsx"
          className={rowData.disableXMLDownload ? "inline-block pointer-events-none opacity-50 cursor-not-allowed" : "inline-block"}
          onClick={() => {
            disableXMLDownload(rowData.id, true);
            setTimeout(() => disableXMLDownload(rowData.id,false), 30000);
          }}
        >
          <img src="/img/downloadxlsx.svg" alt="" className="w-6 h-7" />
        </a>
        <button disabled={rowData.disablePdfDownload}
          onClick={(e) => {
            disablePdfDownload(rowData.id, true);
            setTimeout(() => disablePdfDownload(rowData.id,false), 30000);
            downloadReport(
              rowData.id
            );
          }}
          download="Invoice.pdf"
          className={rowData.disablePdfDownload ? "opacity-50 cursor-not-allowed inline-block mx-8" : "inline-block mx-8"}
        >
          <img src="/img/downloadpdf.svg" alt="" className="w-6 h-7" />
        </button>
        <button
          onClick={(e) => {
            deleteInvoice(rowData.id);
          }}
          download="Invoice.xlsx"
          className="inline-block"
        >
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-6 h-7">
            <g id="Nposbg.tif"><path fill="#ef082e" d="M15.51,0h1a.12.12,0,0,0,.08,0,4.32,4.32,0,0,1,3.68,3.57c0,.17.1.23.26.22.44,0,.88,0,1.32,0,1.27,0,2.54,0,3.8,0a3.59,3.59,0,0,1,3.22,2.91A3.74,3.74,0,0,1,27,10.91a.5.5,0,0,0-.33.54q0,8.39,0,16.78A3.64,3.64,0,0,1,23,32q-7,0-14,0a3.58,3.58,0,0,1-1.51-.34,3.52,3.52,0,0,1-2.13-3.41c0-5.61,0-11.23,0-16.84,0-.2,0-.34-.24-.44A3.76,3.76,0,0,1,3.28,6.3,3.67,3.67,0,0,1,6.86,3.83c1.52,0,3,0,4.56,0,.19,0,.3,0,.34-.25A4.13,4.13,0,0,1,14,.49,10.56,10.56,0,0,1,15.51,0ZM7.12,11.35v.32q0,8.24,0,16.49a1.91,1.91,0,0,0,2.09,2.09q6.8,0,13.58,0a2.56,2.56,0,0,0,.62-.05,1.92,1.92,0,0,0,1.47-2.05V11.35ZM16,5.56H6.86a1.89,1.89,0,0,0-1.77.95,2.05,2.05,0,0,0,0,2.15A2,2,0,0,0,7,9.6H25.22a2,2,0,0,0,1.87-2.74,1.94,1.94,0,0,0-2-1.29Zm2.51-1.75A2.55,2.55,0,0,0,16,1.74a2.51,2.51,0,0,0-2.46,2.07Z"/><path fill="#ef082e" d="M15.14,22.31c0-1.6,0-3.2,0-4.81a.86.86,0,0,1,1.25-.85.88.88,0,0,1,.49.87v9.56a.88.88,0,0,1-1.16.91.89.89,0,0,1-.58-.93Z"/><path fill="#ef082e" d="M10.5,22.28V17.47a.86.86,0,0,1,.95-.91.85.85,0,0,1,.75.69,2.31,2.31,0,0,1,0,.37V27a1.57,1.57,0,0,1-.08.52.85.85,0,0,1-.89.53.86.86,0,0,1-.75-.8c0-.11,0-.23,0-.34Z"/><path fill="#ef082e" d="M21.51,22.3c0,1.62,0,3.23,0,4.84A.85.85,0,0,1,20.4,28a.8.8,0,0,1-.59-.7,3.1,3.1,0,0,1,0-.43V17.72c0-.12,0-.25,0-.37a.86.86,0,0,1,1.71,0c0,1.21,0,2.42,0,3.62Z" /></g></svg>
        </button>
        
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        <span>{moment.monthsShort(rowData.month - 1)}</span>
      </div>
    );
  };
  const CustomCell3 = ({
    rowKeyValue,
    dispatch,
    isSelectedRow,
    selectedRows,
  }) => {
    return (
      <div>
        <input
          type="checkbox"
          checked={isSelectedRow}
          onChange={(event) => {
            if (event.nativeEvent.shiftKey) {
              dispatch1(selectRowsRange(rowKeyValue, [...selectedRows].pop()));
            } else if (event.currentTarget.checked) {
              dispatch1(selectRow(rowKeyValue));
            } else {
              dispatch1(deselectRow(rowKeyValue));
            }
          }}
        />
      </div>
    );
  };
  const CustomCell4 = ({ rowData }) => {
    return (
      <div>
        <span>{rowData?.group ? rowData.group : rowData.unique}</span>
      </div>
    );
  };
  const SelectionHeader = ({ dispatch, areAllRowsSelected }) => {
    return (
      <input
        type="checkbox"
        checked={areAllRowsSelected}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            dispatch(selectAllFilteredRows()); // also available: selectAllVisibleRows(), selectAllRows()
          } else {
            dispatch(deselectAllFilteredRows()); // also available: deselectAllVisibleRows(), deselectAllRows()
          }
        }}
      />
    );
  };
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  useEffect(() => {}, []);
  return (
    <div>
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-full mx-auto">
        <div className="tableHeader flex clearboth">
          <div className="w-full mx-4">
            <ul>
              <li className="inline-block text-xs leading-6 text-fontclr w-1/4">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Parent
                </label>
                <select
                  name="invoiceListParent"
                  aria-label="Select Parent"
                  ref={register({
                    required: true,
                  })}
                  id="invoiceListParent"
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Parent</option>
                  {parentsList
                    ? parentsList.map((parent, i) => {
                        return (
                          <option key={i} value={parent}>
                            {parent}
                          </option>
                        );
                      })
                    : null}
                </select>
              </li>
              <li className="inline-block text-xs leading-6 text-fontclr w-1/4">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Report Month
                </label>
                <select
                  name="invoice_list_month"
                  aria-label="Select Report Month"
                  ref={register({
                    required: false,
                  })}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
                >
                  <option value="0">Select Report Month</option>
                  {totalMonths
                    ? totalMonths.map((monthName, i) => {
                        return (
                          <option key={i} value={("0" + (i + 1)).slice(-2)}>
                            {monthName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </li>
              <li className="inline-block text-xs leading-6 text-fontclr w-1/4">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Report Year
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="invoice_list_year"
                  ref={register({
                    required: false,
                  })}
                  aria-label="Select Report Year"
                  defaultValue={moment().format("YYYY")}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
                >
                  {totalYearsList()}
                </select>
              </li>
              <li className="inline-block text-xs leading-10 text-fontclr w-1/4">
                <button
                  onClick={() => {
                    getInvoiceList();
                  }}
                  type="button"
                  className="text-white w-full h-11 px-6 bg-header_bg rounded text-xs font-semibold capitalize focus:outline-none focus:none relative -top-1"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className={`${showList}`}>
          <div className=" pb-5 text-xs invoiceLst">
          <div className={`  w-1/3 inline-block float-right mt-4 show mb-2 mr-3 ${showList}`}>
              <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-full h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 -top-2 bottom-0"
              ></img>
            </span>
              </div> 
            <Table
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "file_path":
                        return <CustomCell1 {...props} />;
                      case "month":
                        return <CustomCell2 {...props} />;
                      case "selection-cell":
                        return <CustomCell3 {...props} />;
                      case "group":
                         return <CustomCell4 {...props} />;
                        
                    }
                  },
                },
                headCell: {
                  content: (props) => {
                    if (props.column.key === "selection-cell") {
                      return (
                        <SelectionHeader
                          {...props}
                          areAllRowsSelected={kaPropsUtils.areAllFilteredRowsSelected(
                            tableProps
                          )}
                          // areAllRowsSelected={kaPropsUtils.areAllVisibleRowsSelected(tableProps)}
                        />
                      );
                    }
                  },
                },
              }}
              dispatch={dispatch1}
            />
            <div className={` mt-8 show w-full`}>
              <span className="inline-block w-1/4 float-right">
                <button disabled={disablePublish}
                  className={`${disablePublish ? "opacity-50 cursor-not-allowed" : ""} text-white w-11/12 h-10 px-6 bg-header_bg rounded text-xs font-semibold capitalize focus:outline-none focus:none`}
                  onClick={() => {
                    publishInvoice();
                  }}
                >
                  PUBLISH
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(InvoiceList)
);
